core.directive('dateValidator', [
        function() {
            var definition = {
                require: 'ngModel',
                link: function(scope, elm, attrs, ctrl) {
                    //scope.$watch(function () {
                    //    return ctrl.$viewValue;
                    //}, function () {
                    //    ctrl.$render();
                    //
                    //});
                    ////
                    //elm.click(function () {
                    //    ctrl.$render();
                    //    scope.$apply();
                    //    console.log(ctrl);
                    //});


                    //ctrl.$validators.mindate = function(modelValue, viewValue) {
                    //    var minDate = scope.$eval(attrs.mdMinDate);
                    //    if(modelValue >= minDate) {
                    //        return true;
                    //    }
                    //    return false;
                    //}
                }
            };

            return definition;
        }]
);